module.exports = __webpack_public_path__ + "img/title_no.01f07d84.svg";